import styled from "styled-components"
import { Link as DefaultLink } from "../../link/link"

export const Container = styled.div`
  padding: 80px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: center;

  &>img {
    display: block;
    max-height: 526px;
    max-width: 100%;
    width: auto;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`

export const TextContainer = styled.div`
  & > h4 {
    color: #00A687;
    font-family: Ubuntu;
    font-size: 40px;
    font-weight: 700;
    line-height: 45.96px;
    margin-bottom: 16px;
  }

  & > div {
    margin-bottom: 62px;

    & > p {
      color: #1D1D1D;
      font-family: Ubuntu;
      font-size: 24px;
      font-weight: 400;
      line-height: 27.58px;
      margin-bottom: 16px;
    }

    & > ol {
      list-style: disc;
      list-style-position: inside;

      & > li {
        font-family: Source Sans 3;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
      }
    }
  }`

export const Link = styled(DefaultLink)`
  display: inline-block;
  font-family: Ubuntu;
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  text-align: center;
  width: 80%;

  @media (max-width: 768px) {
    width: 100%;
  }
`